export const SET_TV_BOXES = 'SET_TV_BOXES';
